import { render } from "./EmbedChooser.vue?vue&type=template&id=1e479fa9&scoped=true"
import script from "./EmbedChooser.vue?vue&type=script&lang=js"
export * from "./EmbedChooser.vue?vue&type=script&lang=js"

import "./EmbedChooser.vue?vue&type=style&index=0&id=1e479fa9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e479fa9"]])

export default __exports__